import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.containers.setDefaultCourses.title',
        defaultMessage: 'Internal Course Manager'
    },
    setDefault: {
        id: 'app.containers.setDefaultCourses.setDefault',
        defaultMessage: 'Set Default'
    },
    unsavedChanges: {
        id: 'app.containers.setDefaultCourses.unsavedChanges',
        defaultMessage: 'You have unsaved changes and will lose these if you change country'
    },
    defaultCoursesSaved: {
        id: 'app.containers.setDefaultCourses.defaultCoursesSaved',
        defaultMessage: 'Default courses for {country} have been saved'
    },
    defaultCoursesFailure: {
        id: 'app.containers.setDefaultCourses.defaultCoursesFailure',
        defaultMessage: 'Errors have prevented your change from being saved for {country}'
    },
    changeWillBeLost: {
        id: 'app.containers.setDefaultCourses.changeWillBeLost',
        defaultMessage: 'Your changes have not been saved, and will be lost'
    }
});



// WEBPACK FOOTER //
// ./app/containers/set-default-courses/messages.js